<template>
  <div id="events-preview">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Premium Header with Title and Actions -->
    <div class="premium-header">
      <div class="header-content">
        <div class="title-section">
          <v-icon class="title-icon" color="#3A67B1"
            >mdi-file-document-multiple</v-icon
          >
          <h1 class="header-title">{{ pageTitle }}</h1>
        </div>
        <div class="action-buttons">
          <v-btn
            icon
            class="action-btn refresh-btn"
            @click="refreshPageData"
            title="Refresh Data"
          >
            <v-icon color="#3A67B1">mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            icon
            class="action-btn close-btn"
            @click="closePrompt"
            title="Close"
          >
            <v-icon color="#3A67B1">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-card class="preview-card">
      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container v-if="ResultFlag" class="preview-container">
          <!-- Sponsor Details Section -->
          <v-row wrap>
            <v-col cols="12" sm="12" lg="12" md="12">
              <div class="section-header">
                <v-icon class="section-icon" color="#0097D7"
                  >mdi-account-group</v-icon
                >
                <h3 class="section-title">Sponsor Details</h3>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card sponsor-card">
                <div class="card-label">Sponsor Type</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-domain</v-icon>
                  {{ row.SponsorTypeTxt }} <br />
                  <span class="location-text"
                    >{{ row.SponsorZoneName }} - {{ row.SponsorLomName }}</span
                  >
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Sponsor Member Name</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-account</v-icon>
                  {{ row.SponsorMemberName }} <br />
                  <span class="id-text">{{
                    row.SponsorMemberMembershipId
                  }}</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Sponsor Mobile</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-phone</v-icon>
                  {{ row.OrdersMobileNo }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Sponsor Email</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-email</v-icon>
                  {{ row.OrdersEmailId }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Payment Details Section -->
          <v-row wrap class="section-spacing">
            <v-col cols="12" sm="12" lg="12" md="12">
              <div class="section-header">
                <v-icon class="section-icon" color="#EDBE38"
                  >mdi-receipt</v-icon
                >
                <h3 class="section-title">LO Title Payment Details</h3>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Paid Date</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-calendar</v-icon>
                  {{ row.OrdersDate }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Payment ID</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-identifier</v-icon>
                  {{ row.PaymentId }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Payment Method</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-credit-card</v-icon>
                  {{ row.PaymentMethod }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card amount-card">
                <div class="card-label">Paid Amount</div>
                <div class="card-value amount-value">
                  {{ row.TotalAmountTxt }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- LO Title Details Section -->
          <v-row wrap class="section-spacing">
            <v-col cols="12" sm="12" lg="12" md="12">
              <div class="section-header">
                <v-icon class="section-icon" color="#56BDA3"
                  >mdi-briefcase</v-icon
                >
                <h3 class="section-title">LO Title Details</h3>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">LO Title Name</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-text-box</v-icon>
                  {{ row.NewLomsName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">State</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-map</v-icon>
                  {{ row.NewLomStateName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">District</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-map-marker</v-icon>
                  {{ row.NewLomDistrictName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">City</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-city</v-icon>
                  {{ row.NewLomCityName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Expiry Date</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-clock-outline</v-icon>
                  {{ row.ExpiryDateTxt }}
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              lg="3"
              md="3"
              v-if="!previewFlag && row.PaymentApprovalFlag"
            >
              <div class="info-card lady-lo-card">
                <div class="card-label">LO Type</div>
                <v-radio-group
                  v-model="row.IsLadyLo"
                  color="#FF69B4"
                  class="lady-radio"
                >
                  <v-radio :value="1" label="Lady LO"></v-radio>
                  <v-radio :value="0" label="Regular LO"></v-radio>
                </v-radio-group>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3" v-if="!previewFlag">
              <div class="info-card">
                <div class="card-label">Expiry Date</div>
                <v-menu
                  v-model="menu_expiry"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="row.ExpiryDateTxt"
                      readonly
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      class="date-input"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="row.ExpiryDate"
                    @input="onExpiryDateSelect"
                    color="#3A67B1"
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              lg="3"
              md="3"
              v-if="row.LGBResolutionFilePath != ''"
            >
              <v-btn
                :href="row.LGBResolutionFilePath"
                target="_blank"
                class="file-btn"
              >
                <v-icon left color="white">mdi-file-pdf-box</v-icon>
                <span>LGB Resolution</span>
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              lg="3"
              md="3"
              v-if="row.OrientationCertificateFilePath != ''"
            >
              <v-btn
                :href="row.OrientationCertificateFilePath"
                target="_blank"
                class="file-btn"
              >
                <v-icon left color="white">mdi-certificate</v-icon>
                <span>Orientation Certificate</span>
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              lg="3"
              md="3"
              v-if="row.MembershipListFilePath != ''"
            >
              <v-btn
                :href="row.MembershipListFilePath"
                target="_blank"
                class="file-btn"
              >
                <v-icon left color="white">mdi-file-document-multiple</v-icon>
                <span>Membership List</span>
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="row.TitleApprovalDescription != ''">
              <div class="description-card">
                <div class="card-label">Description</div>
                <div class="card-value" v-html="row.TitleApprovalDescription"></div>
              </div>
            </v-col>
          </v-row>
          <!-- Subscription Section -->
          <v-container
            v-if="row.SubscriptionPaymentFlag"
            class="subscription-section"
          >
            <!-- New President Details -->
            <v-row wrap class="section-spacing">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#3A67B1"
                    >mdi-account-tie</v-icon
                  >
                  <h3 class="section-title">New President Details</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Type</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-account</v-icon>
                    {{ row.PresidentsMemberTypeTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Name</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-account</v-icon>
                    {{ row.PresidentsFirstName }} <br />
                    <span class="id-text">{{
                      row.PresidentsMembershipId
                    }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Mobile</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-phone</v-icon>
                    {{ row.PresidentsMobileNo }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Email</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-email</v-icon>
                    {{ row.PresidentsEmailId }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- New Secretary Details -->
            <v-row
              wrap
              class="section-spacing"
              v-if="row.SecretaryJmPresidentsId"
            >
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#0097D7"
                    >mdi-clipboard</v-icon
                  >
                  <h3 class="section-title">New Secretary Details</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Type</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-badge-account</v-icon>
                    {{ row.SecretaryMemberTypeTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Name</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-account</v-icon>
                    {{ row.SecretaryFirstName }} <br />
                    <span class="id-text">{{ row.SecretaryMembershipId }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Mobile</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-phone</v-icon>
                    {{ row.SecretaryMobileNo }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Email</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-email</v-icon>
                    {{ row.SecretaryEmailId }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Subscription Payment Details -->
            <v-row wrap class="section-spacing">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#EDBE38"
                    >mdi-cash-multiple</v-icon
                  >
                  <h3 class="section-title">Subscription Payment Details</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Paid Date</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-calendar</v-icon>
                    {{ row.SubscriptionOrdersDateTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Payment ID</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-identifier</v-icon>
                    {{ row.SubscriptionPaymentId }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Payment Method</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-credit-card</v-icon>
                    {{ row.SubscriptionPaymentMethod }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card amount-card">
                  <div class="card-label">Paid Amount</div>
                  <div class="card-value amount-value">
                    {{ row.SubscriptionTotalAmountTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" v-if="row.Description != ''">
                <div class="description-card">
                  <div class="card-label">Description</div>
                  <div class="card-value" v-html="row.Description"></div>
                </div>
              </v-col>
            </v-row>

            <!-- Subscription Items Table -->
            <v-row wrap class="section-spacing">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#56BDA3"
                    >mdi-table</v-icon
                  >
                  <h3 class="section-title">Subscription Items</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="table-wrapper">
                  <v-data-table
                    class="professional-table"
                    loading-text="Loading... Please wait"
                    disable-sort
                    disable-filtering
                    :item-key="tableOptions1.ItemKey"
                    :headers="tableColumns1"
                    :items="tableData1"
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr
                          v-for="(item, index) in items"
                          :key="index"
                          class="table-row"
                          :class="{ 'even-row': index % 2 === 0 }"
                        >
                          <td
                            v-for="header in tableColumns1"
                            :key="header.value"
                            class="table-cell"
                          >
                            {{ item[header.value] }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <!-- Approval Section -->
          <div v-if="!previewFlag">
            <v-container
              v-if="
                row.TitleApprovalFlag ||
                row.TitleConfirmationFlag ||
                row.PaymentApprovalFlag
              "
              class="approval-section"
            >
              <!-- Header Section -->
              <v-row wrap>
                <v-col cols="12" sm="12" lg="12" md="12">
                  <div class="approval-header">
                    <v-icon large class="header-icon"
                      >mdi-clipboard-check-outline</v-icon
                    >
                    <div class="header-content">
                      <h3 class="header-title">Administrative Review</h3>
                      <p
                        class="header-subtitle"
                        v-if="
                          row.TitleApprovalFlag || row.TitleConfirmationFlag
                        "
                      >
                        New LO Title Administrative Processing
                      </p>
                      <p class="header-subtitle" v-if="row.PaymentApprovalFlag">
                        New LO Subscription Payment Processing
                      </p>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Form Section -->
              <v-form
                ref="form1"
                v-model="valid1"
                lazy-validation
                v-on:submit.prevent="searchForm"
              >
                <!-- Title Approval Section -->
                <v-row wrap v-if="row.TitleApprovalFlag" class="form-section">
                  <v-col cols="12" sm="12" lg="6" md="6">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> New LO Title
                        Name
                      </label>
                      <v-text-field
                        v-model="NewLoName"
                        :rules="NewLoNameRules"
                        hint="Enter the New LO Title Name"
                        outlined
                        dense
                        prepend-inner-icon="mdi-text-box"
                        class="premium-textfield"
                        background-color="#FAFBFC"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" lg="6" md="6">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Approval
                        Description
                      </label>
                      <v-textarea
                        v-model="ApprovalDescription"
                        :rules="ApprovalDescriptionRules"
                        hint="Provide detailed approval notes"
                        outlined
                        dense
                        rows="3"
                        prepend-inner-icon="mdi-pencil"
                        class="premium-textfield"
                        background-color="#FAFBFC"
                      ></v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <!-- Title Confirmation Section -->
                <v-row
                  wrap
                  v-if="row.TitleConfirmationFlag"
                  class="form-section"
                >
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Confirmation
                        Description
                      </label>
                      <v-textarea
                        v-model="ApprovalDescription"
                        :rules="ApprovalDescriptionRules"
                        hint="Provide confirmation notes and remarks"
                        outlined
                        dense
                        rows="4"
                        prepend-inner-icon="mdi-clipboard-text"
                        class="premium-textfield"
                        background-color="#FAFBFC"
                      ></v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <!-- Payment Approval Section -->
                <v-row wrap v-if="row.PaymentApprovalFlag" class="form-section">
                  <v-col cols="12" sm="12" lg="5" md="5">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Provisional
                        Date
                      </label>
                      <div class="date-info-box">
                        <v-icon small class="info-icon"
                          >mdi-information-outline</v-icon
                        >
                        <p class="info-text">
                          Affiliation date will be auto-calculated based on this
                          date
                        </p>
                      </div>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            v-model="ProvisionalDate"
                            label="Select Date"
                            readonly
                            v-on="on"
                            outlined
                            dense
                            prepend-inner-icon="mdi-calendar-range"
                            class="premium-textfield"
                            background-color="#FAFBFC"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="ProvisionalDate"
                          @input="menu1 = false"
                          color="#8950FC"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" lg="7" md="7">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Approval
                        Description
                      </label>
                      <v-textarea
                        v-model="ApprovalDescription"
                        :rules="ApprovalDescriptionRules"
                        hint="Enter approval notes and payment details"
                        outlined
                        dense
                        rows="3"
                        prepend-inner-icon="mdi-note-text"
                        class="premium-textfield"
                        background-color="#FAFBFC"
                      ></v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <!-- Action Buttons Section -->
                <v-row wrap class="action-section">
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <div class="button-group">
                      <v-btn
                        v-if="row.TitleConfirmationFlag"
                        @click.prevent="confirmAlert(1)"
                        :loading="ApproveLoadingFlag"
                        color="#10B981"
                        elevation="0"
                        rounded
                        x-large
                        class="action-btn approve-btn"
                        min-width="180"
                      >
                        <v-icon left>mdi-check-circle</v-icon>
                        Confirm
                      </v-btn>
                      <v-btn
                        v-else
                        @click.prevent="confirmAlert(1)"
                        :loading="ApproveLoadingFlag"
                        color="#10B981"
                        elevation="0"
                        rounded
                        x-large
                        class="action-btn approve-btn"
                        min-width="180"
                      >
                        <v-icon left>mdi-check-circle</v-icon>
                        Approve
                      </v-btn>
                      <v-btn
                        @click.prevent="confirmAlert(2)"
                        :loading="ApproveRejectLoadingFlag"
                        color="#EF4444"
                        elevation="0"
                        rounded
                        x-large
                        class="action-btn reject-btn"
                        min-width="180"
                      >
                        <v-icon left>mdi-close-circle</v-icon>
                        Reject
                      </v-btn>
                      <v-btn
                        @click="closePrompt"
                        color="#6B7280"
                        elevation="0"
                        rounded
                        x-large
                        outlined
                        class="action-btn cancel-btn"
                        min-width="180"
                      >
                        <v-icon left>mdi-cancel</v-icon>
                        Cancel
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewFlag: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
  },
  data() {
    return {
      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      ResultFlag: false,
      LoadingFlag: false,
      row: {},
      PaymentDetails: {},
      selected: [],

      NewLoName: "",
      NewLoNameRules: [(v) => !!v || "Description is required"],
      ApprovalDescription: "",
      ApprovalDescriptionRules: [(v) => !!v || "Description is required"],

      ConfirmationDescription: "",
      ConfirmationDescriptionRules: [(v) => !!v || "Description is required"],

      ApproveLoadingFlag: false,
      ApproveRejectLoadingFlag: false,
      ConfirmationLoadingFlag: false,
      ConfirmationRejectLoadingFlag: false,

      ZoneCode: "",
      LomCode: "",

      tableColumns1: [],
      tableOptions1: {},
      tableData1: [],

      ProvisionalDate: new Date().toISOString().slice(0, 10),
      menu1: false,
      menu_expiry: false,
    };
  },
  computed: {},
  watch: {
    NewLoName: function () {
      console.log("NewLoName watch");
      this.NewLoName = this.NewLoName.toUpperCase();
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      var previewFlag = this.previewFlag;
      if (previewFlag) {
        this.$emit("hidePreviewRecordPrompt");
      } else {
        this.$emit("hideEditRecordPrompt");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var message = "";

      var previewFlag = this.previewFlag;
      console.log({ previewFlag });

      var UserInterface = previewFlag ? 1 : 2;
      console.log({ UserInterface });

      var tr = this.recordData;
      console.log({ tr });

      var OrderId = tr.JmOrdersId;
      var NewLomsId = tr.JmNewLomsId;

      if (OrderId != "" && NewLomsId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/new-lom/show";
        var upload = {
          UserInterface: UserInterface,
          Order: OrderId,
          NewLom: NewLomsId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.row = {};
        this.ResultFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            flag = response.data.flag;
            console.log({ flag });

            output = response.data.output;
            console.log({ output });

            records = response.data.records;
            console.log({ records });

            thisIns.ResultFlag = flag;

            var Subscribtions = records.Subscribtions;
            console.log({ Subscribtions });

            if (flag == 1) {
              thisIns.row = records;
              thisIns.NewLoName = records.NewLomsName;
              // Format ExpiryDateTxt to YYYY-MM-DD if it exists
              if (records.ExpiryDateTxt) {
                thisIns.row.ExpiryDateTxt = thisIns.formatDateToISO(
                  records.ExpiryDateTxt
                );
              }
              thisIns.tableColumns1 = Subscribtions.TableHeader;
              thisIns.tableData1 = Subscribtions.TableData;
              thisIns.tableOptions1 = Subscribtions.TableOptions;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            // thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        if (OrderId == "") {
          message += "Order details are invalid. ";
        }
        if (NewLomsId == "") {
          message += "New LOM details are invalid. ";
        }
        this.toast("error", message);
      }
    },
    onExpiryDateSelect(val) {
      // Sync date-picker value to display text (format: YYYY-MM-DD)
      try {
        this.row.ExpiryDate = val;
        if (!val) {
          this.row.ExpiryDateTxt = "";
          this.menu_expiry = false;
          return;
        }
        const d = new Date(val);
        if (isNaN(d.getTime())) {
          // fallback: use raw value
          this.row.ExpiryDateTxt = val;
        } else {
          // Format as YYYY-MM-DD (e.g., "2022-06-19")
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          this.row.ExpiryDateTxt = `${year}-${month}-${day}`;
        }
        this.menu_expiry = false;
      } catch (err) {
        console.error("onExpiryDateSelect error", err);
      }
    },
    formatDateToISO(dateStr) {
      // Convert any date format (e.g., "29-Mar-2026", "2022-06-19") to YYYY-MM-DD
      try {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) {
          return dateStr; // return as-is if parsing fails
        }
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      } catch (err) {
        console.error("formatDateToISO error", err);
        return dateStr;
      }
    },
    confirmAlert(status) {
      console.log("confirmAlert is called");
      console.log({ status });
      var htmlTxt = "";

      var validate = this.$refs.form1.validate();
      console.log({ validate });

      if (validate) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            switch (status) {
              case 1:
                this.approvalSubmitForm(1);

                break;

              case 2:
                this.approvalSubmitForm(2);

                break;

              default:
                break;
            }
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      }
    },
    approvalSubmitForm(status) {
      console.log("approvalSubmitForm is called");

      console.log({ status });

      var tr = this.row;
      console.log({ tr });

      this.ProgressLoadingFlag = true;

      var OrderId = tr.JmOrdersId;
      console.log({ OrderId });

      var NewLomsId = tr.JmNewLomsId;
      console.log({ NewLomsId });

      var NewPresidentsId = tr.JmPresidentsId;
      console.log({ NewPresidentsId });

      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var OrdersType = tr.OrdersType;
      console.log({ OrdersType });

      var server_url = companyConfig.apiURL;
      var add_url1 = server_url + "api/new-lom-title/approval-status-update";
      var add_url2 = server_url + "api/new-lom-payment/approval-status-update";

      var add_url = OrdersType == 3 ? add_url1 : add_url2;
      console.log({ add_url });

      var UserInterface = OrdersType == 4 ? 1 : tr.TitleApprovalFlag ? 1 : 2;
      console.log({ UserInterface });

      var upload = {
        UserInterface: UserInterface,
        NewLoName: this.NewLoName,
        Order: OrderId,
        NewLom: NewLomsId,
        NewPresident: NewPresidentsId,
        Description: this.ApprovalDescription,
        ProvisionalDate: this.ProvisionalDate,
        Status: status,
        IsLadyLo: this.row.IsLadyLo,
        ExpiryDate: this.row.ExpiryDateTxt,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = {};
      var table = {};
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgressLoadingFlag = false;
          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.$emit("hideEditRecordPrompt");
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SearchFlag = false;
          thisIns.ProgressLoadingFlag = true;
        });
    },
  },
  beforeMount() {
    var ZoneCode = this.$session.get("ZoneId");
    ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
    console.log({ ZoneCode });
    this.ZoneCode = ZoneCode;

    var LomCode = this.$session.get("LomId");
    LomCode = LomCode == (null || undefined) ? "" : LomCode;
    console.log({ LomCode });
    this.LomCode = LomCode;

    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* JCI Approved Colors */
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-dark: #414042;
$text-black: #0a0f29;
$white: #ffffff;

#events-preview {
  /* Premium Header Styling */
  .premium-header {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%);
    padding: 24px;
    box-shadow: 0 4px 20px rgba($navy, 0.15);
    display: flex;
    align-items: center;
    animation: slideDown 0.5s ease-out;

    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .title-section {
      display: flex;
      align-items: center;
      gap: 16px;

      .title-icon {
        font-size: 32px !important;
        animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      }

      .header-title {
        color: $white;
        font-size: 28px;
        font-weight: 700;
        margin: 0;
        letter-spacing: 0.5px;
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        background: rgba($white, 0.2) !important;
        backdrop-filter: blur(10px);
        border-radius: 50%;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        width: 48px !important;
        height: 48px !important;

        &:hover {
          background: rgba($white, 0.3) !important;
          transform: scale(1.1) rotate(5deg);
          box-shadow: 0 8px 24px rgba($navy, 0.3);
        }

        &:active {
          transform: scale(0.95);
        }
      }
    }
  }

  /* Preview Card */
  .preview-card {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba($navy, 0.1);
    animation: fadeInUp 0.6s ease-out;
  }

  .preview-container {
    padding: 24px;
  }

  /* Section Header Styling */
  .section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 3px solid transparent;
    animation: slideIn 0.5s ease-out;

    .section-icon {
      font-size: 28px !important;
    }

    .section-title {
      color: $text-black;
      font-size: 20px;
      font-weight: 700;
      margin: 0;
      letter-spacing: 0.3px;
    }
  }

  /* Section Spacing */
  .section-spacing {
    margin-top: 40px;
    margin-bottom: 40px;
    padding-top: 16px;
    border-top: 1px solid rgba($navy, 0.1);
  }

  /* Info Cards */
  .info-card {
    background: linear-gradient(
      135deg,
      rgba($white, 0.95) 0%,
      rgba($white, 0.98) 100%
    );
    border: 1px solid rgba($navy, 0.1);
    border-radius: 12px;
    padding: 18px;
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    animation: cardFadeIn 0.6s ease-out both;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 24px rgba($navy, 0.15);
      border-color: rgba($navy, 0.3);

      .card-label {
        color: $navy;
      }
    }

    .card-label {
      font-size: 12px;
      font-weight: 600;
      color: $text-dark;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      margin-bottom: 8px;
      transition: color 0.3s ease;
    }

    .card-value {
      color: $text-black;
      font-size: 14px;
      line-height: 1.6;
      display: flex;
      align-items: flex-start;
      gap: 8px;
      flex: 1;

      .value-icon {
        color: $aqua;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .location-text,
      .id-text {
        display: block;
        font-size: 12px;
        color: $text-dark;
        margin-top: 4px;
      }
    }
  }

  /* Sponsor Card */
  .sponsor-card {
    border-left: 4px solid $aqua;

    &:hover {
      border-left-color: $navy;
    }
  }

  /* Amount Card */
  .amount-card {
    background: linear-gradient(
      135deg,
      rgba($gold, 0.1) 0%,
      rgba($gold, 0.05) 100%
    );
    border: 2px solid rgba($gold, 0.3);

    .amount-value {
      color: $gold;
      font-size: 18px;
      font-weight: 700;
    }
  }

  /* Lady LO Card */
  .lady-lo-card {
    border-left: 4px solid #ff69b4;

    &:hover {
      border-left-color: #ff1493;
    }

    .lady-radio {
      margin-top: 8px;

      ::v-deep .v-radio {
        margin-right: 12px;

        .v-radio__label {
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }

  /* Date Input */
  .date-input {
    ::v-deep {
      .v-input__prepend-inner {
        margin-right: 8px;
      }

      .v-input__control {
        .v-input__slot {
          input {
            font-size: 13px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .lady-lo-card {
    border-left: 4px solid #ff69b4;

    .lady-switch {
      margin-top: 8px;

      ::v-deep .v-input__control {
        .v-input__slot {
          margin: 0;
        }
      }
    }
  }

  /* Description Card */
  .description-card {
    background: linear-gradient(
      135deg,
      rgba($seaform, 0.05) 0%,
      rgba($aqua, 0.05) 100%
    );
    border: 1px solid rgba($seaform, 0.2);
    border-radius: 12px;
    padding: 18px;
    animation: cardFadeIn 0.6s ease-out;

    .card-label {
      font-size: 12px;
      font-weight: 600;
      color: $text-dark;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      margin-bottom: 12px;
    }

    .card-value {
      color: $text-black;
      font-size: 14px;
      line-height: 1.8;
    }
  }

  /* File Buttons */
  .file-btn {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 10px 16px !important;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba($navy, 0.25);
    width: 100%;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.5px;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba($navy, 0.35);

      ::v-deep .v-icon {
        animation: spin 0.6s ease-in-out;
      }
    }

    &:active {
      transform: translateY(-1px);
    }

    span {
      display: inline-block;
    }
  }

  /* Table Wrapper */
  .table-wrapper {
    background: $white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba($navy, 0.1);
    animation: fadeIn 0.6s ease-out;

    .professional-table {
      background: transparent !important;

      ::v-deep {
        .table-header {
          background: linear-gradient(135deg, $navy 0%, $aqua 100%);

          .table-header-cell {
            color: $white !important;
            font-weight: 700;
            font-size: 13px;
            padding: 14px !important;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            border-bottom: 2px solid rgba($white, 0.2) !important;
          }
        }

        tbody {
          tr {
            transition: all 0.3s ease;
            border-bottom: 1px solid rgba($navy, 0.08);

            &.even-row {
              background-color: rgba($navy, 0.02);
            }

            &:hover {
              background-color: rgba($aqua, 0.06);
              transform: scaleX(1.01);
              transform-origin: center;
            }

            .table-cell {
              padding: 14px !important;
              color: $text-dark;
              font-size: 13px;
              line-height: 1.6;
            }
          }
        }
      }
    }
  }

  /* Subscription Section */
  .subscription-section {
    margin-top: 32px;
    padding-top: 32px;
    border-top: 2px dashed rgba($navy, 0.15);
  }

  /* Approval Section */
  .approval-section {
    padding: 24px;

    .approval-header {
      display: flex;
      align-items: center;
      gap: 20px;
      padding: 24px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 12px;
      margin-bottom: 32px;
      box-shadow: 0 10px 30px rgba(102, 126, 234, 0.15);

      .header-icon {
        color: white;
        font-size: 40px !important;
      }

      .header-content {
        color: white;

        .header-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 4px 0;
          letter-spacing: -0.5px;
        }

        .header-subtitle {
          font-size: 14px;
          opacity: 0.9;
          margin: 0;
          font-weight: 500;
        }
      }
    }

    .form-section {
      background: #ffffff;
      padding: 24px;
      border-radius: 12px;
      margin-bottom: 24px;
      border: 1px solid #e5e7eb;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        border-color: #d1d5db;
      }
    }

    .form-field-wrapper {
      .form-label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        .required-indicator {
          color: #ef4444;
          margin-right: 4px;
          font-weight: 700;
        }
      }

      .premium-textfield {
        ::v-deep .v-field__outline {
          color: #e5e7eb !important;
        }

        ::v-deep .v-input__control {
          input,
          textarea {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #374151 !important;

            &::placeholder {
              color: #9ca3af !important;
            }
          }
        }

        ::v-deep .v-field:hover {
          .v-field__outline {
            color: #d1d5db !important;
          }
        }

        ::v-deep .v-field.v-field--focused {
          .v-field__outline {
            color: #8950fc !important;
          }
        }

        ::v-deep .v-field__prepend-inner {
          color: #8950fc !important;
        }
      }

      .date-info-box {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        background: #eff6ff;
        padding: 12px;
        border-radius: 8px;
        margin-bottom: 12px;
        border-left: 3px solid #3b82f6;

        .info-icon {
          color: #3b82f6;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .info-text {
          font-size: 12px;
          color: #1e40af;
          margin: 0;
          font-weight: 500;
        }
      }
    }

    .action-section {
      padding: 32px 24px 24px;
      background: linear-gradient(180deg, #f9fafb 0%, #f3f4f6 100%);
      border-radius: 12px;
      margin-top: 32px;
      border: 1px solid #e5e7eb;

      .button-group {
        display: flex;
        gap: 12px;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;

        .action-btn {
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

          &:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          }

          &:active:not(:disabled) {
            transform: translateY(0);
          }

          &.approve-btn {
            color: white !important;
            background: linear-gradient(
              135deg,
              #10b981 0%,
              #059669 100%
            ) !important;

            &:hover:not(:disabled) {
              background: linear-gradient(
                135deg,
                #059669 0%,
                #047857 100%
              ) !important;
            }
          }

          &.reject-btn {
            color: white !important;
            background: linear-gradient(
              135deg,
              #ef4444 0%,
              #dc2626 100%
            ) !important;

            &:hover:not(:disabled) {
              background: linear-gradient(
                135deg,
                #dc2626 0%,
                #b91c1c 100%
              ) !important;
            }
          }

          &.cancel-btn {
            color: #6b7280 !important;
            border: 2px solid #d1d5db !important;
            background: white !important;

            &:hover:not(:disabled) {
              background: #f3f4f6 !important;
              border-color: #9ca3af !important;
            }
          }
        }
      }
    }
  }

  // Responsive adjustments
  @media (max-width: 960px) {
    .approval-section {
      padding: 16px;

      .approval-header {
        flex-direction: column;
        text-align: center;
        padding: 16px;

        .header-icon {
          font-size: 32px !important;
        }

        .header-content {
          .header-title {
            font-size: 20px;
          }
        }
      }

      .action-section {
        .button-group {
          flex-direction: column;

          .action-btn {
            width: 100%;
            min-width: auto;
          }
        }
      }
    }
  }

  /* Form Inputs */
  .form-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: $text-dark;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;

    .text-danger {
      color: #e53935;
    }

    .form-hint {
      font-size: 11px;
      color: $text-dark;
      margin-top: 4px;
      margin-bottom: 0;
      text-transform: none;
    }
  }

  .form-input {
    ::v-deep {
      .v-input__control {
        .v-input__slot {
          background: rgba($white, 0.8);
          border-radius: 8px;

          input {
            color: $text-black;
            font-weight: 500;

            &::placeholder {
              color: rgba($text-dark, 0.5);
            }
          }
        }
      }

      &.v-text-field--outlined {
        fieldset {
          border-color: rgba($navy, 0.2) !important;
          transition: all 0.3s ease;
        }

        &:hover fieldset {
          border-color: rgba($navy, 0.4) !important;
        }

        &.v-input--is-focused fieldset {
          border-color: $navy !important;
          border-width: 2px;
        }
      }
    }
  }

  /* Action Buttons */
  .button-row {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid rgba($navy, 0.1);
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .action-approve-btn {
    background: linear-gradient(135deg, $seaform 0%, $aqua 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 12px 32px !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba($seaform, 0.3);
    min-width: 140px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba($seaform, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .action-reject-btn {
    background: linear-gradient(135deg, #e53935 0%, #d32f2f 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 12px 32px !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(#e53935, 0.3);
    min-width: 140px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(#e53935, 0.4);
    }
  }

  .action-cancel-btn {
    background: linear-gradient(
      135deg,
      $text-dark 0%,
      $text-black 100%
    ) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 12px 32px !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba($text-black, 0.2);
    min-width: 140px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba($text-black, 0.3);
    }
  }

  /* Animations */
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes bounceIn {
    0% {
      opacity: 0;
      transform: scale(0.3);
    }
    50% {
      opacity: 1;
      transform: scale(1.05);
    }
    70% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes cardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .premium-header {
      padding: 16px;

      .header-content {
        flex-direction: column;
        gap: 16px;

        .title-section {
          width: 100%;

          .header-title {
            font-size: 20px;
          }
        }

        .action-buttons {
          width: 100%;
          justify-content: center;
        }
      }
    }

    .info-card {
      margin-bottom: 16px;
    }

    .button-row {
      flex-direction: column;

      .action-approve-btn,
      .action-reject-btn,
      .action-cancel-btn {
        width: 100%;
      }
    }
  }

  /* Loading State */
  ::v-deep .v-overlay {
    background: rgba($text-black, 0.5);
  }
}
</style>